import I18n from 'I18n';
import { useState } from 'react';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import AddItemToPlaylistButton from './AddItemToPlaylistButton';
import MyPlaylistsSearch from './PlaylistSearch';
import RemoveItemFromPlaylistButton from './RemoveItemFromPlaylistButton';
import { LikeLink } from '../../../components/AcademyLinks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'academy-common-lib/utils/Styling';
import { CardMenuOptions } from '../../cardMenu/components/CardMenu';
import { Text } from 'foundations-components/components/Text';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UndoLink = styled(LikeLink).withConfig({
  displayName: "AddToPlaylist__UndoLink",
  componentId: "pf1379-0"
})(["flex:1;text-align:right;"]);
const AddToPlaylistList = ({
  playlists,
  item: {
    id: itemId,
    language,
    type
  },
  renderList = content => /*#__PURE__*/_jsx(CardMenuOptions, {
    "aria-label": I18n.text('academyNav.heading.myPlaylists'),
    children: content
  }),
  renderRow = (content, key) => /*#__PURE__*/_jsx(SideNavItem, {
    inlineSize: "100%",
    title: content
  }, key),
  onPlaylistClick
}) => {
  const [recentlyAdded, setRecentlyAdded] = useState([]);
  const handledAddedToPlaylist = playlistId => setRecentlyAdded(state => [...state, playlistId]);
  const handledRemovedFromPlaylist = playlistId => setRecentlyAdded(state => state.filter(id => id !== playlistId));
  return renderList(playlists && playlists.map(({
    name,
    id
  }) => {
    const showUndo = recentlyAdded.includes(id);
    const ButtonComponent = showUndo ? RemoveItemFromPlaylistButton : AddItemToPlaylistButton;
    return renderRow( /*#__PURE__*/_jsx(ButtonComponent, {
      block: true,
      itemId: itemId,
      itemType: type,
      language: language,
      onClick: () => {
        if (onPlaylistClick) onPlaylistClick(id);
      },
      onSuccess: () => showUndo ? handledRemovedFromPlaylist(id) : handledAddedToPlaylist(id),
      playlistId: id,
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          textAlign: "left",
          children: name
        }), /*#__PURE__*/_jsx(UndoLink, {
          style: {
            visibility: showUndo ? 'visible' : 'hidden'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.cardMenu.undo"
          })
        })]
      })
    }), `playlist_${id}`);
  }));
};
const AddToPlaylist = ({
  item,
  renderList,
  renderRow,
  loadMoreButton,
  loadMode = 'lazy-load',
  onPlaylistClick
}) => {
  return /*#__PURE__*/_jsx(MyPlaylistsSearch, {
    loadMode: loadMode,
    loadMoreButton: loadMoreButton,
    render: playlists => playlists && /*#__PURE__*/_jsx(AddToPlaylistList, {
      item: item,
      onPlaylistClick: onPlaylistClick,
      playlists: playlists,
      renderList: renderList,
      renderRow: renderRow
    })
  });
};
export default AddToPlaylist;